import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const NavigationMobile = ({ links, isOpen, onClickContact }) => {
  return (
    <Root open={isOpen}>
      <nav>
        {links.map((link, index) => {
          if (link.url === '/contact') {
            return (
              <a onClick={onClickContact} key={index}>
                <span>{link.title}</span>
              </a>
            );
          }
          return (
            <Link key={index} to={link.url}>
              {link.title}
            </Link>
          );
        })}
      </nav>
      <LanguageSelect>
        <Link to="/">EN</Link>
        <Link to="/zh">中文</Link>
      </LanguageSelect>
    </Root>
  );
};

NavigationMobile.propTypes = {
  links: PropTypes.array,
  isOpen: PropTypes.bool,
  onClickContact: PropTypes.func,
};

NavigationMobile.defaultProps = {
  links: [],
  isOpen: false,
  onClickContact: f => f,
};

const Root = styled.div`
  background: ${({ theme }) => theme.colorBackground};
  position: absolute;
  top: calc(100% - 1px);
  color: #fff;
  height: calc(100vh - 61px);
  width: 100%;
  max-height: ${props => (props.open ? '100vh' : '0px')};
  overflow: hidden;
  transition: max-height 0.5s;
  display: none;
  pointer-events: none;
  @media (max-width: ${({ theme }) => theme.headerMobileWidth}) {
    display: block;
    pointer-events: auto;
  }
  nav {
    width: 100%;
    padding: 0 45px;
    padding-top: 30px;
    a {
      display: block;
      padding: 15px 0;
      color: #fff;
      border-bottom: 1px solid #fff;
      font-size: 11px;
      text-align: left;
      text-transform: uppercase;
      letter-spacing: 1.8px;
      &:hover {
        font-weight: bold;
      }
    }
  }
`;

const LanguageSelect = styled.div`
  text-align: left;
  padding: 30px 45px 0;
  a {
    display: block;
    color: #fff;
    font-size: 11px;
    letter-spacing: 1.83px;
    margin-bottom: 15px;
  }
`;

export default NavigationMobile;



// WEBPACK FOOTER //
// ./src/components/Header/elements/NavigationMobile.js